import isEmpty from 'lodash/isEmpty'
import { memo, useMemo } from 'react'

import Card from '@/components/elements/card'
import JobOfferCard from '@/components/elements/cards/jobOfferCard/jobOfferCard'
import HeaderOverhaul from '@/components/elements/headerOverhaul'

const NO_OFFER_TEXT = "We currently don't have any offer available"

const JobOffers = ({ data }) => {
  const { header, offers } = data
  const showOffers = useMemo(() => offers && offers.data && !isEmpty(offers.data), [
    offers
  ])

  return (
    <div>
      <HeaderOverhaul header={header} subtitle />
      <div className="job-offers-container">
        {showOffers ? (
          <div className="job-offers-grid grid-wrapper grid-columns-2-1">
            {offers.data.map(
              ({ id, attributes: { name, subtitle, description, technologies } }) => (
                <JobOfferCard
                  key={id}
                  id={id}
                  name={name}
                  subtitle={subtitle}
                  description={description}
                  technologies={technologies.data}
                />
              )
            )}
          </div>
        ) : (
          <Card placeholder={NO_OFFER_TEXT} />
        )}
      </div>
    </div>
  )
}

export default memo(JobOffers)
